import { Method } from '../../constants.js';
export const buildSuccessAttemptPayload = (successAttemptParams) => {
    const { eventName, componentTitle, loginSource, componentState, loginMethod, uniqueName, } = successAttemptParams;
    return {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: componentTitle,
            linkName: uniqueName,
        },
        trackingData: {
            eventName,
            loginSource,
            ...(loginMethod === 'standard' && { datalayerUpdateTriggered: 'true' }),
            loginMethod,
            ...(componentState && { componentState }),
            allowLinkBeforeView: true,
        },
    };
};
//# sourceMappingURL=buildSuccessAttemptPayload.js.map